import { Action } from 'redux';
import { Children } from '../../models/Discussions/Children';
import {
    CREATE_CHILDREN_ERROR,
    CREATE_CHILDREN_REQUEST,
    CREATE_CHILDREN_RESPONSE, DELETE_CHILDREN_ERROR, DELETE_CHILDREN_REQUEST, DELETE_CHILDREN_RESPONSE,
    EDIT_CHILDREN_ERROR,
    EDIT_CHILDREN_REQUEST,
    EDIT_CHILDREN_RESPONSE,
    GET_CHILDREN_ERROR,
    GET_CHILDREN_REQUEST,
    GET_CHILDREN_RESPONSE
} from '../../actions/Discussions/children';

export interface ChildrenState {
    children: Array<Children>;
    loading: boolean;
    error: any;
}

const initialState: ChildrenState = {
    children: Array<Children>(),
    loading: false,
    error: null
};

export function childrenState(state: ChildrenState = initialState, action: Action) {
    switch (action.type) {
        case GET_CHILDREN_REQUEST: case EDIT_CHILDREN_REQUEST: case CREATE_CHILDREN_REQUEST: case DELETE_CHILDREN_REQUEST: {
            return {
                ...state,
                loading: true,
                error: initialState.error,
            };
        }
        case GET_CHILDREN_RESPONSE: {
            const children: Children[] = (action as any).response.result;
            return {
                ...state,
                loading: false,
                children
            };
        }
        case GET_CHILDREN_ERROR: case EDIT_CHILDREN_ERROR: case CREATE_CHILDREN_ERROR: case DELETE_CHILDREN_ERROR: {
            const error = (action as any).error;
            return {
                ...state,
                loading: false,
                error
            };
        }
        case CREATE_CHILDREN_RESPONSE: {
            const child: Children = (action as any).response.result;
            let children = state.children;
            children.push(child);
            return {
                ...state,
                children,
                loading: false,
            };
        }
        case EDIT_CHILDREN_RESPONSE: {
            const child: Children = (action as any).response.result;
            const children = state.children.map(c => c.id === child.id ? child : c);
            return {
                ...state,
                children,
                loading: false,
            };
        }
        case DELETE_CHILDREN_RESPONSE: {
            return {
                ...state,
                loading: false,
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/Discussions/children.ts